import { observer } from "mobx-react";
import { InputAdornment, TextField } from "@mui/material";
import React from "react";
import useTranslation from "../../hooks/useTranslation";
import { Search } from "@mui/icons-material";
import { debounce } from "lodash";
import "./SearchBar.scss";

interface SearchBarProps {
  handleOnSearch: (keyword: string) => void;
}

const SearchBar = observer(({ handleOnSearch }: SearchBarProps) => {
  const { t } = useTranslation();
  const searchInputProps = {
    endAdornment: (
      <InputAdornment position={"end"}>
        <Search />
      </InputAdornment>
    ),
  };

  const handleSearchTextChange = debounce((keyword) => {
    handleOnSearch(keyword);
  }, 500);

  return (
    <div className="searchBar">
      <TextField
        fullWidth
        onChange={(e) => handleSearchTextChange(e.target.value)}
        label={`${t("search")}...`}
        variant="outlined"
        size={"small"}
        InputProps={searchInputProps}
      />
    </div>
  );
});

export default SearchBar;
